// extracted by mini-css-extract-plugin
module.exports = {"content":"ReassuranceBannerPaymentModal_content__5oaW2","block":"ReassuranceBannerPaymentModal_block__bhUhz"};